import {
  GET_FOOTER_PARTNERS_PENDING,
  GET_FOOTER_PARTNERS_REJECTED,
  GET_FOOTER_PARTNERS_FULFILLED,
} from "../../constants/footerPartners";

const footerPartners = (state = {}, action) => {
  switch (action.type) {
    case GET_FOOTER_PARTNERS_PENDING:
      return { ...state, loading: true, error: false, success: false };
    case GET_FOOTER_PARTNERS_REJECTED:
      return { ...state, loading: false, error: true, success: false };
    case GET_FOOTER_PARTNERS_FULFILLED:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        footerPartnersData: action.payload.data,
      };
    default:
      return state;
  }
};

export default footerPartners;
